/**
* 系统管理 用户管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>学校管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.name" clearable placeholder="学校名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.username" clearable placeholder="账号"></el-input>
      </el-form-item>


      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->

    <el-table size="small" :data="userData" v-loading="loading" border element-loading-text="拼命加载中"
              style="width: 100%;">
      <el-table-column align="center" prop="name" label="学校名称" width="120">
      </el-table-column>
      <el-table-column align="center" prop="userName" label="账号" width="120">
      </el-table-column>

      <el-table-column align="center" prop="passWord" label="密码" width="120">
      </el-table-column>
      <el-table-column align="center" prop="email" label="邮箱" width="180">
      </el-table-column>
      <el-table-column align="center" prop="express" label="快递价格" width="180">
      </el-table-column>
      <el-table-column align="center" prop="upstairsPrice" label="上楼价格" width="180">
      </el-table-column>
      <el-table-column align="center" prop="role" label="账号类型" width="120" :formatter="sample">
      </el-table-column>
      <el-table-column align="center" prop="createdAt" label="创建时间" width="180">
      </el-table-column>

      <el-table-column label="操作" min-width="350">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>

          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
        <el-form-item label="学校名称" prop="name">
          <el-input size="small" v-model="editForm.name" clearable maxlength="20" auto-complete="off"
                    placeholder="请输入学校名称"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="userName">
          <el-input size="small" v-model="editForm.userName" clearable maxlength="20" auto-complete="off"
                    placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="学校标识" prop="mark">
          <el-input size="small" v-model="editForm.mark" clearable maxlength="20" auto-complete="off"
                    placeholder="请输入学校标识"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input size="small" v-model="editForm.email" clearable maxlength="50" auto-complete="off"
                    placeholder="请输入邮箱账号"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input size="small" v-model="editForm.phoneNumber" clearable maxlength="11" auto-complete="off"
                    placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="passWord">
          <el-input size="small" v-model="editForm.passWord" clearable maxlength="20" auto-complete="off"
                    placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="快递价格" prop="express">
          <el-input size="small" v-model="editForm.express" clearable type="number" maxlength="10" auto-complete="off"
                    placeholder="请输入快递价格"></el-input>
        </el-form-item>
        <el-form-item label="上楼价格" prop="upstairsPrice">
          <el-input size="small" v-model="editForm.upstairsPrice" clearable type="number" maxlength="10" auto-complete="off"
                    placeholder="请输入上楼价格"></el-input>
        </el-form-item>
        <el-form-item label="账号类型" prop="role">
          <el-select size="small" v-model="editForm.role" clearable placeholder="账号类型">
            <el-option label="管理员" value="0"></el-option>
            <el-option label="学校" value="1"></el-option>
          </el-select>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// 导入请求方法
import {
  selectAllManage,
  updateManage,
  insertManage,
  delectManage,
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {pcaTextArr} from "element-china-area-data";

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加车辆',
      isUpdate: false,
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示

      //地区选择
      options: pcaTextArr,
      selectedOptions: [],
      openingRegionArray: [],
      openingRegionOneArray: [],
      //分部
      selectBranchList: [],

      driverlineList: [],
      // 编辑与添加
      editForm: {
        id: '',
        name: '',
        userName: '',
        passWord: '',
        phoneNumber:'',
        role:'',
        email:'',
        mark:'',
        express:'',
        upstairsPrice:'',

      },


      // rules表单验证
      rules: {
        brand: [
          {required: true, message: '请输入车辆品牌', trigger: 'blur'},
          {
            validator: function (rule, value, callback) {
              //校验中文的正则：/^[\u4e00-\u9fa5]{0,}$/
              if (/^[\u4e00-\u9fa5]+$/.test(value) == false) {
                callback(new Error("请输入中文"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        vehiclemodel: [
          {required: true, message: '请输入车辆型号', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请输入学校名称', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
        passWord: [
          {required: true, message: '请输入密码', trigger: 'blur'}
        ],
        phoneNumber: [
          {required: true, message: '请输入手机号', trigger: 'blur'}
        ],
        role: [
          {required: true, message: '请选择类别', trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入邮箱账号', trigger: 'blur'}
        ],
        mark: [
          {required: true, message: '请输入标识', trigger: 'blur'}
        ],
        express: [
          {required: true, message: '请输入快递价格', trigger: 'blur'}
        ],
        upstairsPrice: [
          {required: true, message: '请输入上楼价格', trigger: 'blur'}
        ],
        // userSex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },

      // 请求数据参数
      formInline: {
        limit: 1,
        page: 10,
        name: '',
        username: '',

      },
      //用户数据
      userData: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //行驶证上传
    handleRemove(file, fileList) {
      console.log(file + '-------' + fileList);
    },
    handlePreview(file) {
      console.log(file);
    },

    sample(row, column, cellValue) {
      if (cellValue == '0') {
        return '管理员'
      } else {
        return '学校'
      }
    },
    association(row, column, cellValue) {
      if (cellValue == true) {
        return '已关联'
      } else {
        return '未关联'
      }
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // 获取用户列表
      console.log('parameter', parameter);
      selectAllManage(parameter).then(res => {
        this.loading = false
        console.log('res---', res)
        if (res.status == 200) {
          this.userData = res.data.list;
          // 分页赋值
          this.pageparm.currentPage = this.formInline.limit;
          this.pageparm.pageSize = this.formInline.page;
          this.pageparm.total = res.data.totalRow;
        } else {
          this.$message({
            type: 'info',
            message: res.message
          })

        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.pageSize
      this.formInline.limit = parm.currentPage
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      console.log(row)
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.isUpdate = true;
        this.editForm.id = row.id;
        this.editForm.name = row.name
        this.editForm.userName = row.userName
        this.editForm.passWord = row.passWord
        this.editForm.phoneNumber = row.mobile
        this.editForm.express = row.express
        this.editForm.upstairsPrice = row.upstairsPrice


        this.editForm.email = row.email
        this.editForm.mark = row.mark
        if (row.role=='0'){
          this.editForm.role = '管理员'
        }else {
          this.editForm.role = '学校'

        }
      } else {
        this.title = '添加'
        this.isUpdate = false;
        // this.editForm.name = ''
        // this.editForm.userName = ''
        // this.editForm.passWord = ''
        // this.editForm.phoneNumber = ''
      }
    },
    // 编辑、添加提交方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.isUpdate == false) {
            // 请求方法
            insertManage(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.status == 200) {
                  this.getdata(this.formInline)
                  this.$message({
                    type: 'success',
                    message: '数据保存成功！'
                  })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          } else {
            updateManage(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                this.isUpdate = false;
                console.log('res+++++', res);
                if (res.status == 200) {
                  this.$message({
                    type: 'success',
                    message: '修改成功！'
                  })
                  this.getdata(this.formInline)

                } else {
                  this.$message({
                    type: 'info',
                    message: res.message
                  })
                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('保存失败，请稍后再试！')
              })
          }

        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    // 删除用户
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 删除
          delectManage(row.id)
            .then(res => {
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '数据已删除!'
                })
                if (this.pageparm.total <= 11) {
                  this.formInline.limit = 1;
                }
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    inspectEdit(index, row) {
      this.$confirm('是否确认已年审车辆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 年审
          goInspectVehicle(row.id)
            .then(res => {
              if (res.status == 200) {
                this.$message({
                  type: 'success',
                  message: '车辆已年审!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('数据删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除！'
          })
        })
    },

    // 详情
    detailUser(index, row) {
      setTimeout(() => {
        this.logining = false
        this.$router.push({path: 'vehicleDetail/detail', query: row})
      }, 1000)
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/school.vue